const toErrorMessage = (value) => {
  if (value == null || value === "") return ""
  if (typeof value === "string") return value
  if (Array.isArray(value)) return toErrorMessage(value[0])
  if (typeof value === "object") {
    if (value.message) return toErrorMessage(value.message)
    if (value.detail) return toErrorMessage(value.detail)
  }
  return String(value)
}

/**
 * Parse DRF-style API errors into form field keys.
 * @param {object|string|null} errorData - error.response.data
 * @param {Record<string, string>} fieldMap - API field name -> form field name
 */
export const parseApiFormErrors = (errorData, fieldMap = {}) => {
  if (!errorData) {
    return { fieldErrors: {}, generalError: "" }
  }

  if (typeof errorData === "string") {
    return { fieldErrors: {}, generalError: errorData }
  }

  if (errorData.detail) {
    return { fieldErrors: {}, generalError: toErrorMessage(errorData.detail) }
  }

  if (errorData.message && typeof errorData.message === "string") {
    return { fieldErrors: {}, generalError: errorData.message }
  }

  const fieldErrors = {}

  Object.entries(errorData).forEach(([apiField, value]) => {
    const message = toErrorMessage(value)
    if (!message) return
    const formField = fieldMap[apiField] || apiField
    fieldErrors[formField] = message
  })

  return { fieldErrors, generalError: "" }
}

export const getFirstFormError = (fieldErrors, fallback = "") =>
  Object.values(fieldErrors).find(Boolean) || fallback
